import installFunction, {$toast} from './src/toast';
import VToast from './src/toast/components/VToast.vue';
export default installFunction;
export { VToast, $toast };